(function(){
  if (window.__dfxCartInit) return;
  window.__dfxCartInit = true;

  var drawer, scrim, body, totalEl, toastEl, nudgeEl, toastT;

  function $(s){ return document.querySelector(s); }
  function money(cents){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style:'currency', currency: window.DFX_CURRENCY || 'EUR'
      }).format(cents/100);
    } catch(e){ return (cents/100).toFixed(2); }
  }

  function toast(msg){
    if(!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 2600);
  }

  function open(){ drawer.classList.add('is-on'); scrim.classList.add('is-on'); drawer.setAttribute('aria-hidden','false'); }
  function close(){ drawer.classList.remove('is-on'); scrim.classList.remove('is-on'); drawer.setAttribute('aria-hidden','true'); }

  function setCount(n){
    document.querySelectorAll('.dfn__count').forEach(function(el){ el.textContent = n; });
  }

  /* buy 2 get 1 free + free shipping progress */
  function renderNudge(cart){
    if(!nudgeEl) return;
    var count = cart.item_count, total = cart.total_price;
    var need = 3 - count, gap = 8000 - total, msg, cls = '';

    if(count === 0){
      msg = 'Buy any 2 dolls and the third is free';
    } else if(need === 2){
      msg = 'Add 2 more dolls and one of them is <strong>free</strong>';
    } else if(need === 1){
      msg = 'Add 1 more doll and it is <strong>free</strong> \u2014 any one you like';
    } else {
      msg = 'Buy 2 get 1 free applied';
      cls = ' dfx-nudge__t--won';
    }

    var ship = gap > 0
      ? '<p class="dfx-nudge__s">' + money(gap) + ' away from free shipping</p>'
      : '<p class="dfx-nudge__s dfx-nudge__s--won">Free shipping unlocked</p>';

    var pct = count >= 3 ? 100 : count * 33;
    var ico = cls ? '\u2713' : '\u2605';

    nudgeEl.innerHTML =
      '<div class="dfx-nudge" style="margin:14px 20px 0">' +
        '<p class="dfx-nudge__t' + cls + '"><span class="dfx-nudge__ico">' + ico + '</span>' + msg + '</p>' +
        ship +
        '<div class="dfx-nudge__bar"><span style="width:' + pct + '%"></span></div>' +
      '</div>';
  }

  function render(cart){
    setCount(cart.item_count);
    if(totalEl) totalEl.textContent = money(cart.total_price);
    renderNudge(cart);
    if(!body) return;
    if(!cart.items.length){
      body.innerHTML = '<div class="dfx-drawer__empty">' +
        (window.DFX_MARK ? '<img src="' + window.DFX_MARK + '" alt="">' : '') +
        '<p>Your cart is empty.</p>' +
        (window.DFX_SHOP_URL ? '<a class="dfx-btn" style="text-decoration:none" href="' + window.DFX_SHOP_URL + '">Shop the collection</a>' : '') +
        '</div>';
      return;
    }
    body.innerHTML = cart.items.map(function(it, i){
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '<span></span>';
      var disc = '';
      if(it.line_level_discount_allocations && it.line_level_discount_allocations.length){
        disc = it.line_level_discount_allocations.map(function(a){
          return '<div class="dfx-ci__p" style="font-size:11.5px">' + a.discount_application.title + ' \u2212' + money(a.amount) + '</div>';
        }).join('');
      }
      return '<div class="dfx-ci">' + img +
        '<div><a class="dfx-ci__n" href="' + it.url + '">' + it.product_title + '</a>' +
        '<div class="dfx-ci__p">' + money(it.final_line_price) + '</div>' + disc +
        '<div class="dfx-ci__q">' +
          '<button type="button" data-dfx-line="' + (i+1) + '" data-dfx-to="' + (it.quantity-1) + '" aria-label="Decrease">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-dfx-line="' + (i+1) + '" data-dfx-to="' + (it.quantity+1) + '" aria-label="Increase">+</button>' +
        '</div></div>' +
        '<button class="dfx-ci__rm" data-dfx-line="' + (i+1) + '" data-dfx-to="0">Remove</button></div>';
    }).join('');
  }

  function refresh(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); }).then(render);
  }

  function change(line, qty){
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({line: line, quantity: qty})
    }).then(function(r){ return r.json(); }).then(render);
  }

  document.addEventListener('DOMContentLoaded', function(){
    drawer = $('#dfx-drawer'); scrim = $('#dfx-scrim');
    body = $('#dfx-drawer-body'); totalEl = $('#dfx-drawer-total');
    toastEl = $('#dfx-toast'); nudgeEl = $('#dfx-drawer-nudge');
    if(!drawer) return;

    $('#dfx-drawer-close').addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

    document.querySelectorAll('a[href$="/cart"]').forEach(function(a){
      if(a.closest('.dfx-drawer')) return;
      a.addEventListener('click', function(ev){ ev.preventDefault(); refresh().then(open); });
    });

    body.addEventListener('click', function(ev){
      var b = ev.target.closest('[data-dfx-line]');
      if(!b) return;
      change(parseInt(b.getAttribute('data-dfx-line'),10), parseInt(b.getAttribute('data-dfx-to'),10));
    });

    document.addEventListener('submit', function(ev){
      var f = ev.target;
      if(!f.action || f.action.indexOf('/cart/add') === -1) return;
      ev.preventDefault();
      var btn = f.querySelector('[name="add"]');
      if(btn) btn.disabled = true;
      fetch('/cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(f)})
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
        .then(function(res){
          if(btn) btn.disabled = false;
          if(!res.ok){ toast(res.j.description || 'Could not add that item.'); return; }
          toast((res.j.product_title || 'Item') + ' added to your cart');
          return refresh().then(open);
        })
        .catch(function(){ if(btn) btn.disabled = false; toast('Something went wrong. Please try again.'); });
    });

    refresh();
  });
})();
